import { BiddingStrategies, Improvement, Targets } from '../../../index'
import { resources, common, enums } from '../../../gads'
import { GadsFieldsRequired, GadsFields } from '../../../utils/global'
import { LocationGeometry } from '../../../maps'

export enum LocationTargetType {
    POSTAL_CODE = 'postal_code',
    CITY = 'city',
    COUNTY = 'county',
    STATE = 'state',
    REGION = 'region',
    COUNTRY = 'country',
}

export const VALID_LOOKBACK_WINDOWS = [
    Improvement.LookbackWindow.THIRTY_DAYS,
    Improvement.LookbackWindow.NINETY_DAYS,
    Improvement.LookbackWindow.ONE_YEAR,
] as const // maintain the order of this array (30, 90, 180)

export type LookbackWindowValue = (typeof VALID_LOOKBACK_WINDOWS)[number]

export interface Body {
    location: Required<Pick<GeographicView, 'geographic_view' | 'metrics' | 'information'>>
    campaigns: {
        id: number
        name: string
        resource_name: string
        budget_capped: boolean
        advertising_channel_type: string
        advertising_channel_sub_type: string
        cost_micros?: number
        all_conversions?: number
        all_conversions_value?: number
    }[]
    window: LookbackWindowValue
    target_type: LocationTargetType
    bid_generation: BiddingStrategies.BidGenerationReturn
    campaign_group: { name: string; cpa: number; roas: number }
    geometry?: LocationGeometry
    performance_mode: Targets.PerformanceMode
}

export interface ExtraDetails {
    new_bid_modifier: number
}

export interface GeographicView {
    campaigns: number[]
    geographic_view: GadsFieldsRequired<
        resources.GeographicView,
        'resource_name' | 'country_criterion_id'
    >
    metrics: Metrics
    information: {
        id: number
        name: string
        canonical_name: string
        country_code: string
        target_type: string
        all_parent_ids: number[]
        bid_modifier: number
        status: enums.GeoTargetConstantStatus
    }
    segments?: GadsFields<
        common.Segments,
        | 'geo_target_postal_code'
        | 'geo_target_city'
        | 'geo_target_county'
        | 'geo_target_state'
        | 'geo_target_region'
    >
}

export type Metrics = GadsFieldsRequired<
    common.Metrics,
    | 'impressions'
    | 'clicks'
    | 'cost_micros'
    | 'all_conversions'
    | 'conversions'
    | 'all_conversions_value'
    | 'view_through_conversions'
>

export const NUMBER_TO_LOCATION_STATUS = new Map<number, enums.GeoTargetConstantStatus>([
    [0, enums.GeoTargetConstantStatus.UNSPECIFIED],
    [1, enums.GeoTargetConstantStatus.UNKNOWN],
    [2, enums.GeoTargetConstantStatus.ENABLED],
    [3, enums.GeoTargetConstantStatus.REMOVAL_PLANNED],
])
